import type { Signal } from "@preact/signals";

import type { WindowLabel } from "@/api/types";
import { t, tOr } from "@/i18n";

// Short operational windows + the longer trend windows (year-over-year is the
// product purpose, and data is retained 365 days). 90/180/365 days parse on the
// backend (\d+d) and read as "3 Mte / 6 Mte / Max" in German, "3 mo / 6 mo /
// Max" in English; the short ones show as-is.
const WINDOWS: WindowLabel[] = ["24h", "7d", "90d", "180d", "365d"];

export function WindowSelector({
  value,
  options = WINDOWS,
}: {
  value: Signal<WindowLabel>;
  options?: WindowLabel[];
}) {
  return (
    <div class="toolbar">
      <span class="muted">{t("header.window")}</span>
      {options.map((w) => (
        <button
          key={w}
          class={`window-pill ${value.value === w ? "active" : ""}`}
          onClick={() => (value.value = w)}
        >
          {tOr(`window.${w}`, w)}
        </button>
      ))}
    </div>
  );
}
